import { RefCallback, useCallback, useState } from 'react';

export const useNode = () => {
  const [node, setNode] = useState<HTMLElement | null>(null);

  const ref: RefCallback<HTMLElement> = useCallback(node => setNode(node), []);

  return { ref, node };
};
